import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/Index'
import Download from '@/pages/download'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    component: Index,
    meta: {
      title: '乐学宝-海量知识库'
    }
  },
  {
    path: '/download',
    component: Download,
    meta: {
      title: '乐学宝-海量知识库-下载app'
    }
  }
]

export const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes, // (缩写) 相当于 routes: routes
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js